/**
 * TableSkeleton — list-page loading shimmer.
 *
 * Drop-in replacement for the centred `<Loader2 />` spinner used on
 * data-list pages. Renders N skeleton rows that match a shadcn `<Table>`'s
 * column widths. Animation uses Tailwind's built-in `animate-pulse` so no
 * external lib needed.
 *
 * Usage inside a Card / Table area:
 *   {loading ? <TableSkeleton rows={6} columns={6} /> : <RealTable .../>}
 */
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export function TableSkeleton({
  rows = 6,
  columns = 5,
  showHeader = false,
  headers = [],
  testid = 'table-skeleton',
}) {
  const cols = Array.from({ length: columns });
  const list = Array.from({ length: rows });
  return (
    <div data-testid={testid}>
      <Table>
        {showHeader && (
          <TableHeader>
            <TableRow>
              {(headers.length ? headers : cols).map((h, i) => (
                <TableHead key={i}>
                  {headers.length ? h : <Skeleton className="h-3 w-20" />}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
        )}
        <TableBody>
          {list.map((_, r) => (
            <TableRow key={r}>
              {cols.map((__, c) => (
                <TableCell key={c}>
                  <Skeleton className={`h-4 ${c === 0 ? 'w-24' : c === columns - 1 ? 'w-16' : 'w-32'}`} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export default TableSkeleton;
